export default function checkTldFromDomainQuery(query: string): string {
  const dotIndex = query.indexOf('.');
  return dotIndex !== -1 ? query.substring(dotIndex) : 'NULL';
}
